(() => {
  const meld = (naam, data) => {
    const stuur = () => { try { window.Shopify.analytics.publish('spg_verzamel_' + naam, data || {}); } catch (_) {} };
    if (window.Shopify?.analytics?.publish) stuur(); else window.addEventListener('load', stuur, { once: true });
  };

  const lees = (sleutel) => {
    try {
      const d = JSON.parse(localStorage.getItem(sleutel) || 'null');
      if (d && Array.isArray(d.heb) && Array.isArray(d.wil)) return { heb: d.heb.map(String), wil: d.wil.map(String) };
    } catch (_) {}
    return { heb: [], wil: [] };
  };
  const schrijf = (sleutel, lijst) => {
    let ok = true;
    try { localStorage.setItem(sleutel, JSON.stringify({ heb: lijst.heb, wil: lijst.wil, pad: location.pathname })); } catch (_) { ok = false; }
    document.dispatchEvent(new CustomEvent('spg-verzamel', { detail: { sleutel } }));
    return ok;
  };

  const LIJSTJE = 'spg-lijstje-v1';
  const MAX_LIJSTJE = 30;
  const lijstje = {
    lees() {
      try {
        const d = JSON.parse(localStorage.getItem(LIJSTJE) || '{}');
        return d && typeof d === 'object' ? { ...d, ids: Array.isArray(d.ids) ? d.ids.filter(Number.isFinite) : [] } : { ids: [] };
      } catch (_) { return { ids: [] }; }
    },
    zet(id, aan) {
      const d = this.lees();
      const had = d.ids.includes(id);
      if (aan && !had && d.ids.length < MAX_LIJSTJE) d.ids.push(id);
      if (!aan && had) { d.ids = d.ids.filter((x) => x !== id); if (d.fav === id) d.fav = null; }
      try { localStorage.setItem(LIJSTJE, JSON.stringify(d)); } catch (_) {}
      document.dispatchEvent(new CustomEvent('spg-lijstje', { detail: d }));
      return d.ids;
    }
  };

  const uitLink = (geldig) => {
    const q = new URL(location.href).searchParams;
    if (!q.has('heb') && !q.has('wil')) return null;
    const deel = (k) => (q.get(k) || '').split(',').map((s) => s.trim()).filter((s) => geldig.has(s));
    return { heb: deel('heb'), wil: deel('wil') };
  };

  const start = (root) => {
    if (root.dataset.klaar) return;
    root.dataset.klaar = '1';
    const sleutel = 'spg-verzamel-' + (root.dataset.serie || 'lijst');
    let T = {};
    try { T = JSON.parse(root.querySelector('script[data-spg-vl-tekst]').textContent) || {}; } catch (_) { T = {}; }
    const tk = (k, nl, w) => String(typeof T[k] === 'string' && T[k] ? T[k] : nl).replace(/\{(\w+)\}/g, (m, n) => (w && w[n] != null ? String(w[n]) : m));
    const sets = [...root.querySelectorAll('[data-spg-vl-set]')];
    const nummers = new Set(sets.map((s) => s.dataset.spgVlSet));
    const teller = root.querySelector('[data-spg-vl-teller]');
    const leeg = root.querySelector('[data-spg-vl-leeg]');
    const gedeeldVak = root.querySelector('[data-spg-vl-gedeeld]');
    const bewaardRegel = root.querySelector('[data-spg-vl-bewaard]');
    const filters = [...root.querySelectorAll('[data-spg-vl-filter]')];
    const jaren = [...root.querySelectorAll('[data-spg-vl-jaar]')];
    const jaarKeus = root.querySelector('[data-spg-vl-jaarfilter]');
    const jaarVan = new Map();
    let vlJaar = '';
    root.querySelectorAll('[data-spg-vl-jaar], [data-spg-vl-set]').forEach((el) => {
      if (el.hasAttribute('data-spg-vl-jaar')) vlJaar = el.dataset.spgVlJaar;
      else jaarVan.set(el, vlJaar);
    });
    const noppen = new Map([...root.querySelectorAll('[data-spg-vl-nop]')].map((n) => [n.dataset.spgVlNop, n]));

    const productVan = new Map(sets.filter((s) => s.dataset.productId).map((s) => [s.dataset.spgVlSet, Number(s.dataset.productId)]));
    const naarLijst = root.querySelector('[data-spg-vl-naar-lijst]');
    const toonNaarLijst = (ids) => { if (naarLijst) naarLijst.hidden = !ids.length; };

    let eigen = lees(sleutel);
    eigen = { heb: eigen.heb.filter((n) => nummers.has(n)), wil: eigen.wil.filter((n) => nummers.has(n)) };
    const opLijstje = lijstje.lees().ids;
    let erbij = false;
    productVan.forEach((id, nr) => {
      if (opLijstje.includes(id) && !eigen.wil.includes(nr)) {
        eigen.wil.push(nr);
        eigen.heb = eigen.heb.filter((x) => x !== nr);
        erbij = true;
      }
    });
    // bewaar het, zodat de voortgang op het verlanglijstje en het account hetzelfde zien
    if (erbij) schrijf(sleutel, eigen);
    toonNaarLijst(opLijstje);
    const syncLijstje = (nr, aan) => { if (productVan.has(nr)) toonNaarLijst(lijstje.zet(productVan.get(nr), aan)); };
    const gedeeld = uitLink(nummers);
    let lijst = gedeeld || eigen;
    let filter = 'alles';
    let jaar = '';

    root.querySelectorAll('[data-spg-vl-balk], [data-spg-vl-acties], [data-spg-vl-knoppen]').forEach((el) => { el.hidden = false; });
    root.querySelectorAll('img[data-spg-vl-extern]').forEach((img) => img.addEventListener('error', () => { img.closest('.spg-vl-set__beeld').classList.add('spg-vl-set__beeld--leeg'); img.remove(); }, { once: true }));

    const teken = () => {
      const heb = new Set(lijst.heb);
      const wil = new Set(lijst.wil);
      let zichtbaar = 0;
      sets.forEach((el) => {
        const nr = el.dataset.spgVlSet;
        const h = heb.has(nr);
        const w = wil.has(nr);
        el.querySelector('[data-spg-vl-zet="heb"]').setAttribute('aria-pressed', String(h));
        el.querySelector('[data-spg-vl-zet="wil"]').setAttribute('aria-pressed', String(w));
        el.classList.toggle('spg-vl-set--heb', h);
        el.classList.toggle('spg-vl-set--wil', w);
        const nop = noppen.get(nr);
        if (nop) nop.className = h ? 'is-heb' : w ? 'is-wil' : '';
        const toon = (filter === 'alles' || (filter === 'heb' && h) || (filter === 'wil' && w) || (filter === 'mist' && !h)) && (!jaar || jaarVan.get(el) === jaar);
        el.hidden = !toon;
        if (toon) zichtbaar++;
      });
      const totaal = sets.length;
      const mist = totaal - heb.size;
      teller.textContent = heb.size === 0 && wil.size === 0
        ? tk('js_start', 'Vink aan wat je al hebt en wat je nog wilt.')
        : tk('js_stand', 'Je hebt {heb} van de {totaal}.', { heb: heb.size, totaal }) + ' ' + (mist === 0 ? tk('js_compleet', 'Je hebt de hele serie!') : wil.size ? tk('js_mist_wil', 'Je mist er nog {mist}, {wil} op je verlanglijst.', { mist, wil: wil.size }) : tk('js_mist', 'Je mist er nog {mist}.', { mist }));
      // jaarkop alleen tonen als er onder hem nog een set zichtbaar is
      jaren.forEach((kop) => {
        let el = kop.nextElementSibling;
        let toon = false;
        while (el && !el.hasAttribute('data-spg-vl-jaar')) { if (!el.hidden) { toon = true; break; } el = el.nextElementSibling; }
        kop.hidden = !toon;
      });
      leeg.hidden = zichtbaar > 0;
      leeg.textContent = filter === 'wil' ? tk('js_leeg_wil', 'Nog niets op je verlanglijst. Tik bij een set op Wil ik.') : filter === 'heb' ? tk('js_leeg_heb', 'Nog niets aangevinkt als Heb ik.') : tk('js_leeg_alles', 'Je hebt ze allemaal.');
      filters.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.spgVlFilter === filter)));
      gedeeldVak.hidden = lijst !== gedeeld || !gedeeld;
    };

    const zet = (nr, soort) => {
      if (lijst === gedeeld) lijst = eigen;
      const andere = soort === 'heb' ? 'wil' : 'heb';
      const aan = !lijst[soort].includes(nr);
      lijst[soort] = aan ? [...lijst[soort], nr] : lijst[soort].filter((x) => x !== nr);
      if (aan) lijst[andere] = lijst[andere].filter((x) => x !== nr);
      if (soort === 'wil' || aan) syncLijstje(nr, soort === 'wil' && aan);
      eigen = lijst;
      if (!schrijf(sleutel, eigen) && bewaardRegel) bewaardRegel.textContent = tk('js_bewaren_fout', 'Bewaren lukt niet in deze browser. Deel of print je lijst om hem te bewaren.');
      meld(soort, { set: nr, aan, serie: root.dataset.serie });
      teken();
    };

    sets.forEach((el) => el.querySelectorAll('[data-spg-vl-zet]').forEach((b) => b.addEventListener('click', () => zet(el.dataset.spgVlSet, b.dataset.spgVlZet))));
    filters.forEach((b) => b.addEventListener('click', () => { filter = b.dataset.spgVlFilter; meld('filter', { filter, serie: root.dataset.serie }); teken(); }));
    jaarKeus?.addEventListener('change', () => { jaar = jaarKeus.value; meld('jaar', { jaar: jaar || 'alle', serie: root.dataset.serie }); teken(); });

    root.querySelector('[data-spg-vl-overnemen]')?.addEventListener('click', () => {
      eigen.wil.forEach((nr) => { if (!gedeeld.wil.includes(nr)) syncLijstje(nr, false); });
      eigen = { heb: [...gedeeld.heb], wil: [...gedeeld.wil] };
      eigen.wil.forEach((nr) => syncLijstje(nr, true));
      schrijf(sleutel, eigen);
      lijst = eigen;
      meld('overnemen', { serie: root.dataset.serie });
      teken();
    });
    root.querySelector('[data-spg-vl-terug]')?.addEventListener('click', () => { lijst = eigen; teken(); });

    const deelKnop = root.querySelector('[data-spg-vl-deel]');
    deelKnop.addEventListener('click', async () => {
      const u = new URL(location.pathname, location.origin);
      if (lijst.heb.length) u.searchParams.set('heb', lijst.heb.join(','));
      if (lijst.wil.length) u.searchParams.set('wil', lijst.wil.join(','));
      u.hash = root.id;
      const tekst = lijst.wil.length ? tk('js_deel_wil', 'Mijn LEGO-verlanglijst: {sets}', { sets: lijst.wil.join(', ') }) : tk('js_deel_leeg', 'Mijn LEGO-verzamellijst');
      meld('deel', { heb: lijst.heb.length, wil: lijst.wil.length, serie: root.dataset.serie });
      try {
        if (navigator.share) { await navigator.share({ title: document.title, text: tekst, url: u.href }); return; }
      } catch (e) { if (e && e.name === 'AbortError') return; }
      try {
        await navigator.clipboard.writeText(u.href);
        deelKnop.textContent = tk('js_gekopieerd', 'Link gekopieerd');
        setTimeout(() => { deelKnop.textContent = tk('js_deel', 'Deel mijn verlanglijst'); }, 2500);
      } catch (_) {
        window.prompt(tk('js_kopieer', 'Kopieer deze link:'), u.href);
      }
    });

    root.querySelector('[data-spg-vl-print]').addEventListener('click', () => {
      meld('print', { serie: root.dataset.serie });
      filter = 'alles';
      jaar = '';
      if (jaarKeus) jaarKeus.value = '';
      teken();
      const pad = [];
      for (let el = root.parentElement; el && el !== document.documentElement; el = el.parentElement) { el.classList.add('spg-vl-pad'); pad.push(el); }
      root.classList.add('spg-vl-actief');
      document.documentElement.classList.add('spg-vl-print');
      window.addEventListener('afterprint', () => {
        document.documentElement.classList.remove('spg-vl-print');
        root.classList.remove('spg-vl-actief');
        pad.forEach((el) => el.classList.remove('spg-vl-pad'));
      }, { once: true });
      window.print();
    });

    document.addEventListener('spg-verzamel-extern', () => {
      const nu = lees(sleutel);
      const waren = lijst === eigen;
      eigen = { heb: nu.heb.filter((n) => nummers.has(n)), wil: nu.wil.filter((n) => nummers.has(n)) };
      if (waren) lijst = eigen;
      teken();
    });

    if (gedeeld) meld('gedeeld_open', { serie: root.dataset.serie });
    teken();
  };

  const alles = () => document.querySelectorAll('[data-spg-vl]').forEach(start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alles); else alles();
  document.addEventListener('shopify:section:load', alles);
})();
